import { SvgIconRegistry } from '../../_import/svg-icon-registry';

export const SVG_ICONS: SvgIconRegistry[] = [

  {
    name:  'logo',
    filename: 'telioev-logo.svg'
  }

];

